import {
  getCheckoutLink,
  getRoomsSearchParamsFromApUrl
} from 'modules/accommodation/utils'
import {MetaState} from 'types/State'

import {RoomWithoutOffers} from '@daedalus/core/src/room/types/room'
import {BaseUrlCheckoutParams} from '@daedalus/core/src/utils/url/types/UrlParams'

export const getSplitBookingCheckoutLink = ({
  meta,
  redirectId,
  landingTrafficSource,
  sbCheckoutUrl,
  bundleId,
  room,
  providerRateType,
  providerCode,
  cug,
  searchId,
  offerPerks,
  showTotalPrices
}: {
  meta: MetaState
  redirectId: string
  landingTrafficSource: string
  sbCheckoutUrl: string
  bundleId: string
  room: RoomWithoutOffers
  providerRateType: string
  providerCode: string
  cug: string[]
  searchId: string
  offerPerks?: string
  showTotalPrices: boolean
}) => {
  const selectedBundle = getRoomsSearchParamsFromApUrl()
  const paymentPageParams: Partial<BaseUrlCheckoutParams> = {
    // Meta
    anonymousId: meta.anonymousId,
    deviceType: meta.deviceCategory,
    searchId,
    utm_source: landingTrafficSource,
    // Link analytics between search-checkout by passing the same value as the ProviderRedirected event
    redirectId,
    roomsBundleId: bundleId,
    // required for PP
    roomId: room?.id,
    providerRateType,
    providerCode,
    cug: cug ? cug[0] : '',
    baseRate: selectedBundle?.clickedOfferBaseRate?.toString(),
    tax: selectedBundle?.clickedOfferTaxes?.toString(),
    localTax: selectedBundle?.clickedOfferHotelFees?.toString(),
    bundleId: selectedBundle?.bundleId,
    offerPerks,
    // Enable offer-matching instead of relying on offer.id on payment page
    isDirectToPayment: '1',
    showTotalPrices: showTotalPrices ? '1' : '0'
  }

  return getCheckoutLink({checkoutUrl: sbCheckoutUrl, paymentPageParams})
}
